import React, { useMemo, useState } from "react";
import { Field, useFormState } from "react-final-form";
import { getData } from "country-list";
import BootstrapInput from "../../../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../../../components/Autocomplete";

export default function ServiceProvider() {
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );
  const { values } = useFormState();
  const serviceProviderCountry =
    values.serviceProviderProfile.serviceProvider?.country;

  return (
    <>
      <Field
        required
        fullWidth
        type="text"
        name="serviceProviderProfile.serviceProvider.name"
        label="Service Provider Name"
        placeholder="Service Provider Name"
        component={BootstrapInput}
      />
      <Field
        required
        disabled={!!serviceProviderCountry}
        fullWidth
        name="serviceProviderProfile.serviceProvider.country"
        label="Country"
        options={countries}
        placeholder="Please Select"
        component={Autocomplete}
      />
      <Field
        required
        fullWidth
        type="text"
        name="serviceProviderProfile.serviceProvider.website"
        label="Service Provider Website"
        placeholder="www.edu.uk"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        type="text"
        name="name"
        label="Representative Name"
        placeholder="John Smith"
        component={BootstrapInput}
      />
    </>
  );
}
